module.exports = __webpack_public_path__ + "static/media/logo70.70e57f0e.jpg";